export const triggerDownloadUrl = (url: string): void => {
  if (!url) {
    return;
  }
  // Avoid popup blockers by navigating in the current tab.
  window.location.assign(url);
};
